<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>
    <div class="topBox flex" style="justify-content: space-between; align-items: flex-start; flex-wrap: wrap">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div
          v-if="activeMainTab === 'all'"
          class="flex"
          style="align-items: center; margin-right: 12px; margin-bottom: 4px"
        >
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <div style="width: 220px">
            <el-select v-model="query.status" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">标题：</span>
          <div style="width: 260px">
            <el-input v-model="query.title" placeholder="输入商品标题关键字" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">卖家：</span>
          <div style="width: 220px">
            <el-input
              v-model="query.sellerNickName"
              placeholder="卖家昵称关键字"
              clearable
              @keyup.enter.native="searchFn"
            />
          </div>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <el-tabs
      v-if="showManualAuditUi"
      v-model="activeMainTab"
      type="card"
      class="secondhand-main-tabs"
      @tab-click="handleMainTabClick"
    >
      <el-tab-pane label="商品列表" name="all" />
      <el-tab-pane label="人工审核" name="audit" />
    </el-tabs>

    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="productNo" label="商品编号" width="160" align="center" />
      <el-table-column label="图片" width="110" align="center">
        <template slot-scope="scope">
          <img
            v-if="firstImage(scope.row.images)"
            :src="firstImage(scope.row.images)"
            style="width: 60px; height: 60px; object-fit: cover; cursor: pointer"
            @click="previewFn(firstImage(scope.row.images))"
          />
          <span v-else>无</span>
        </template>
      </el-table-column>

      <el-table-column prop="title" label="标题" min-width="220" />
      <el-table-column label="商品描述" min-width="200">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            :content="scope.row.description || '-'"
            popper-class="secondhand-desc-tooltip"
          >
            <div class="desc-cell-ellipsis">{{ scope.row.description || "-" }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-if="activeMainTab === 'all'" prop="status" label="状态" width="130" align="center">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status) }">{{ statusLabel(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="售价(元)" width="110" align="center" />
      <el-table-column prop="sellerNickName" label="卖家(昵称)" width="140" align="center" />
      <el-table-column v-if="showManualAuditUi" label="机审不通过次数" width="140" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 4">{{
            scope.row.sellerViolationCount != null ? scope.row.sellerViolationCount : "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="showManualAuditUi" label="违规原因" min-width="260">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 4">
            <el-tooltip
              effect="dark"
              placement="top"
              :content="scope.row.violationReason || '-'"
              popper-class="secondhand-desc-tooltip"
            >
              <div class="desc-cell-ellipsis">{{ scope.row.violationReason || "-" }}</div>
            </el-tooltip>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="300" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="detailFn(scope.row)">详情</el-button>
          <el-button size="small" type="primary" plain @click="editFn(scope.row)">编辑</el-button>

          <el-button
            v-if="showManualAuditUi && scope.row.status === 4"
            type="warning"
            size="small"
            plain
            @click="openAuditDialog(scope.row)"
          >
            人工审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>

    <!-- 详情弹窗：分区标题 + 每区三列网格，主体可滚动 -->
    <el-dialog title="商品详情" :visible.sync="detailVisible" width="980px" custom-class="secondhand-detail-dialog">
      <div v-if="detail" class="detail-dialog-body">
        <section class="detail-section">
          <h4 class="detail-section__title">基础信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">商品编号</div>
              <div class="detail-field-value">{{ detail.productNo }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">标题</div>
              <div class="detail-field-value">{{ detail.title }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">分类</div>
              <div class="detail-field-value">{{ detail.categoryName || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">描述</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.description || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">品牌</div>
              <div class="detail-field-value">{{ detail.brandName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">香型</div>
              <div class="detail-field-value">{{ detail.typeName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">成色</div>
              <div class="detail-field-value">{{ conditionLabel(detail.conditionLevel) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">扩展属性</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">购买渠道</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.purchaseChannel, purchaseChannelList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">保质期</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.shelfLife, shelfLifeList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">规格类型</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.specType, specTypeList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">适用性别</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.gender, genderList) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">卖家与价格</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家</div>
              <div class="detail-field-value">
                <div class="detail-seller-row">
                  <img
                    v-if="detail.sellerPhoto"
                    class="detail-seller-avatar"
                    :src="detail.sellerPhoto"
                    alt=""
                    @click="previewFn(detail.sellerPhoto)"
                  />
                  <span>{{ detail.sellerNickName || "-" }}</span>
                  <span v-if="detail.sellerUserId != null" class="detail-seller-uid">（用户ID：{{ detail.sellerUserId }}）</span>
                </div>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">原价(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.originalPrice) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">售价(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.price) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">库存数量</div>
              <div class="detail-field-value">{{ detail.quantity != null ? detail.quantity : "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--span2">
              <div class="detail-field-label">可选数量</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowQuantitySelect) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">物流与交易</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">配送方式</div>
              <div class="detail-field-value">{{ labelInList(detail.deliveryType, deliveryTypeList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">运费(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.freight) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">所在地</div>
              <div class="detail-field-value">{{ detail.location || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">允许砍价</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowBargain) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">最低砍价(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.minBargainPrice) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">订金比例</div>
              <div class="detail-field-value">{{ formatPercent(detail.depositRate) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">订金金额(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.depositAmount) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支持验货</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowInspection) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">验货费(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.inspectionFee) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">数据与状态</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">浏览 / 点赞</div>
              <div class="detail-field-value">
                {{ detail.viewCount != null ? detail.viewCount : "-" }} / {{ detail.likeCount != null ? detail.likeCount : "-" }}
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">创建时间</div>
              <div class="detail-field-value">{{ formatTime(detail.createTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">更新时间</div>
              <div class="detail-field-value">{{ formatTime(detail.updateTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">状态</div>
              <div class="detail-field-value" :style="{ color: statusColor(detail.status) }">
                {{ statusLabel(detail.status) }}
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--span2">
              <div class="detail-field-label">机审不通过次数</div>
              <div class="detail-field-value">{{ detail.sellerViolationCount }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section detail-section--last">
          <h4 class="detail-section__title">审核与违规</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">违规原因</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.violationReason)"
                  :disabled="detailTooltipDisabled(detail.violationReason)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.violationReason || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核人</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.auditBy)"
                  :disabled="detailTooltipDisabled(detail.auditBy)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.auditBy || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核时间</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="formatTime(detail.auditTime)"
                  :disabled="!detail.auditTime"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ formatTime(detail.auditTime) }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核备注</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.auditRemark)"
                  :disabled="detailTooltipDisabled(detail.auditRemark)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.auditRemark || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </section>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 人工审核：通过 / 驳回 / 取消 -->
    <el-dialog
      title="人工审核"
      :visible.sync="auditDialogVisible"
      width="640px"
      custom-class="secondhand-audit-dialog"
      :close-on-click-modal="false"
      @closed="onAuditDialogClosed"
    >
      <div v-if="auditRow" class="audit-dialog-body">
        <p class="audit-dialog-line"><strong>商品编号</strong>：{{ auditRow.productNo }}</p>
        <p class="audit-dialog-line"><strong>标题</strong>：{{ auditRow.title || "-" }}</p>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">商品描述</div>
          <div class="audit-dialog-desc">{{ auditDescriptionDisplay(auditRow) }}</div>
        </div>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">商品图片</div>
          <div v-if="imageList(auditRow.images).length" class="audit-dialog-images">
            <img
              v-for="(url, idx) in imageList(auditRow.images)"
              :key="idx"
              :src="url"
              alt=""
              @click="previewFn(url)"
            />
          </div>
          <span v-else class="audit-dialog-empty">无</span>
        </div>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">违规原因</div>
          <div class="audit-dialog-violation">{{ auditRow.violationReason || "-" }}</div>
        </div>

        <div class="audit-dialog-remark">
          <div class="audit-dialog-remark__label">驳回原因（点击「驳回」时必填）</div>
          <el-input
            v-model="auditRejectRemark"
            type="textarea"
            :rows="4"
            placeholder="通过可不填；驳回时请填写原因"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="auditSubmitLoading" @click="submitAuditReject">驳回</el-button>
        <el-button type="success" :loading="auditSubmitLoading" @click="submitAuditApprove">通过</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      title="编辑商品"
      :visible.sync="editVisible"
      width="640px"
      custom-class="secondhand-edit-dialog"
      :close-on-click-modal="false"
      @closed="onEditDialogClosed"
    >
      <div v-loading="editLoading">
        <el-form
          v-if="editForm"
          ref="editFormRef"
          :model="editForm"
          :rules="editRules"
          label-width="108px"
          size="small"
        >
          <el-form-item label="商品图片">
            <div class="sh-img-upload">
              <div class="sh-img-upload__grid">
                <div v-for="(imgUrl, idx) in editImageUrls" :key="idx" class="sh-img-upload__thumb">
                  <img :src="imgUrl" alt="" @click="previewFn(imgUrl)" />
                  <span class="sh-img-upload__remove" title="删除" @click.stop="removeEditImage(idx)">
                    <i class="el-icon-close"></i>
                  </span>
                </div>
                <el-upload
                  v-if="editImageUrls.length < 9"
                  class="sh-img-upload__trigger"
                  :show-file-list="false"
                  :disabled="editImageUploading"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  :http-request="uploadEditImageRequest"
                >
                  <div
                    class="sh-img-upload__add"
                    :class="{ 'is-loading': editImageUploading }"
                  >
                    <i v-if="!editImageUploading" class="el-icon-plus sh-img-upload__add-icon"></i>
                    <i v-else class="el-icon-loading sh-img-upload__add-icon"></i>
                    <span class="sh-img-upload__add-text">{{
                      editImageUploading ? "上传中…" : "添加图片"
                    }}</span>
                  </div>
                </el-upload>
              </div>
              <p class="sh-img-upload__hint">支持 JPG / PNG / GIF / WebP，单张建议不超过 5MB，最多 9 张</p>
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="editForm.title" maxlength="200" show-word-limit placeholder="商品标题" />
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="editForm.description"
              type="textarea"
              :rows="4"
              maxlength="400"
              show-word-limit
              placeholder="商品描述"
            />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <div class="edit-status-row">
              <el-select v-model="editForm.status" placeholder="请选择" style="width: 100%">
                <el-option v-for="s in editStatusOptions" :key="s.value" :label="s.label" :value="s.value" />
              </el-select>
              <div class="edit-status-hint">「上架」即前台展示；「下架」即前台不展示</div>
            </div>
          </el-form-item>
          <el-form-item label="售价(元)" prop="price">
            <el-input-number
              v-model="editForm.price"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item v-if="!isOfficialConsignList" label="原价(元)" prop="originalPrice">
            <el-input-number v-model="editForm.originalPrice" :min="0" :precision="2" :step="1" controls-position="right" style="width: 100%" />
          </el-form-item>
          <el-form-item label="库存数量" prop="quantity">
            <el-input-number v-model="editForm.quantity" :min="1" :precision="0" :step="1" controls-position="right" style="width: 100%" />
          </el-form-item>
          <el-divider content-position="left">渠道/规格/成色等扩展</el-divider>
          <el-form-item label="成色" prop="conditionLevel">
            <el-select v-model="editForm.conditionLevel" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="c in conditionList" :key="c.value" :label="c.label" :value="c.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="购买渠道">
            <el-select v-model="editForm.purchaseChannel" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="p in purchaseChannelList" :key="p.value" :label="p.label" :value="p.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="保质期">
            <el-select v-model="editForm.shelfLife" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="s in shelfLifeList" :key="s.value" :label="s.label" :value="s.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="规格类型">
            <el-select v-model="editForm.specType" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="s in specTypeList" :key="s.value" :label="s.label" :value="s.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="适用性别">
            <el-select v-model="editForm.gender" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="g in genderList" :key="g.value" :label="g.label" :value="g.value" />
            </el-select>
          </el-form-item>
          <el-divider content-position="left">配送配置</el-divider>
          <el-form-item label="配送方式" prop="deliveryType">
            <el-select
              v-model="editForm.deliveryType"
              placeholder="请选择"
              style="width: 100%"
              @change="onEditDeliveryTypeChange"
            >
              <el-option v-for="d in deliveryTypeFormOptions" :key="d.value" :label="d.label" :value="d.value" />
            </el-select>
          </el-form-item>
          <template v-if="Number(editForm.deliveryType) === 1">
            <el-form-item label="快递运费">
              <el-radio-group v-model="editForm.expressFreightMode" @change="onEditExpressFreightModeChange">
                <el-radio label="free">包邮</el-radio>
                <el-radio label="custom">自定义邮费</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="editForm.expressFreightMode === 'custom'" label="邮费(元)" prop="freight">
              <el-input-number
                v-model="editForm.freight"
                :min="0.01"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 100%"
              />
            </el-form-item>
          </template>
          <el-form-item label="所在地区">
            <el-cascader
              v-model="editForm.regionCodes"
              :options="regionCascaderOptions"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              placeholder="请选择省 / 市 / 区"
              style="width: 100%"
              @change="onEditRegionChange"
            />
            <div
              v-if="editForm.location && (!editForm.regionCodes || !editForm.regionCodes.length)"
              class="official-publish-field-hint"
            >
              当前保存：{{ editForm.location }}（可重新选择以更新）
            </div>
          </el-form-item>

          <el-divider content-position="left">还价与保证金</el-divider>
          <el-form-item label="接受还价" prop="allowBargain">
            <el-select
              v-model="editForm.allowBargain"
              placeholder="请选择"
              style="width: 100%"
              @change="onEditAllowBargainChange"
            >
              <el-option label="否" :value="0" />
              <el-option label="是" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="editForm.allowBargain === 1" label="还价最低(元)" prop="minBargainPrice">
            <el-input-number
              v-model="editForm.minBargainPrice"
              :min="0.01"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div class="edit-bargain-hint">须低于售价；接受还价时必填</div>
          </el-form-item>
          <el-form-item label="保证金比例" prop="depositRate"  v-show="editForm.allowBargain === 1" >
            <el-input-number
              v-model="editForm.depositRate"
              :min="0"
              :max="1"
              :precision="2"
              :step="0.01"
              controls-position="right"
              style="width: 100%"
            />
            <div class="edit-bargain-hint">如 0.05 表示 5%，按售价计算保证金时使用</div>
          </el-form-item>
          <el-form-item label="保证金金额(元)" prop="depositAmount"  v-show="editForm.allowBargain === 1" >
            <el-input-number
              v-model="editForm.depositAmount"
              :min="0"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div class="edit-bargain-hint">若填写固定金额则优先于比例；可不填</div>
          </el-form-item>

          <template v-if="!isOfficialConsignList">
            <el-divider content-position="left">安心购</el-divider>
            <el-form-item label="支持安心购" prop="allowInspection">
              <el-select
                v-model="editForm.allowInspection"
                placeholder="请选择"
                style="width: 100%"
                @change="onEditAllowInspectionChange"
              >
                <el-option label="否" :value="0" />
                <el-option label="是" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="editForm.allowInspection === 1"
              label="安心购费用(元)"
              prop="inspectionFee"
            >
              <el-input-number
                v-model="editForm.inspectionFee"
                :min="0"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 100%"
              />
              <div class="edit-bargain-hint">不填则使用系统默认费用</div>
            </el-form-item>
          </template>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitLoading" @click="submitEditFn">保存</el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：代用户发闲置（卖家=官方帐号，货主=寄售用户） -->
    <el-dialog
      title="发闲置（官方寄售）"
      :visible.sync="officialPublishVisible"
      width="820px"
      top="5vh"
      custom-class="secondhand-official-publish-dialog"
      :close-on-click-modal="false"
      @closed="onOfficialPublishDialogClosed"
    >
      <div v-loading="officialPublishLoading" class="official-publish-wrap">
        <p class="official-publish-tip">
          由所选官方帐号作为卖家上架展示，货主为寄售用户；便于前台展示与筛选。
        </p>
        <div class="official-publish-body">
          <el-form
            v-if="officialPublishForm"
            ref="officialPublishFormRef"
            :model="officialPublishForm"
            :rules="officialPublishRules"
            label-width="122px"
            size="small"
          >
            <el-divider content-position="left">上架帐号</el-divider>
            <el-form-item label="官方帐号" prop="officialSellerUserId" class="official-publish-official-item">
              <el-select
                v-model="officialPublishForm.officialSellerUserId"
                placeholder="请选择作为卖家的官方帐号"
                style="width: 100%"
                filterable
                popper-class="official-publish-official-dropdown"
              >
                <el-option
                  v-for="acc in officialAccountList"
                  :key="'oa-' + acc.id"
                  :label="officialAccountOptionLabel(acc)"
                  :value="acc.officialUserId"
                >
                  <div class="official-account-opt">
                    <div class="official-account-opt__avatar-wrap">
                      <img v-if="acc.photo" :src="acc.photo" alt="" class="official-account-opt__avatar" />
                      <span v-else class="official-account-opt__avatar official-account-opt__avatar--ph">
                        <i class="el-icon-user-solid"></i>
                      </span>
                    </div>
                    <div class="official-account-opt__meta">
                      <div class="official-account-opt__nick">{{ displayOfficialAccountNick(acc) }}</div>
                      <div class="official-account-opt__sub">
                        用户 ID {{ acc.officialUserId != null ? acc.officialUserId : "—" }}
                        <template v-if="acc.remark"> · {{ acc.remark }}</template>
                      </div>
                    </div>
                  </div>
                </el-option>
              </el-select>
              <div class="official-publish-field-hint">
                前台展示卖家为该帐号；若配置多个官方帐号，可在此切换。
              </div>
            </el-form-item>

            <el-divider content-position="left">寄售货主</el-divider>
            <el-form-item label="寄售货主" prop="consignorUserId" class="official-publish-consignor-item">
              <el-select
                v-model="officialPublishForm.consignorUserId"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="昵称搜索并选择"
                :remote-method="remoteSearchConsignorUser"
                :loading="consignorSearchLoading"
                style="width: 100%"
              >
                <el-option
                  v-for="u in consignorSearchOptions"
                  :key="'c-' + u.id"
                  :label="consignorUserOptionLabel(u)"
                  :value="u.id"
                />
              </el-select>
              <div class="official-publish-field-hint">将作为货主（consignor）</div>
            </el-form-item>

            <el-divider content-position="left">商品信息</el-divider>
            <el-form-item label="商品图片" required>
              <div class="sh-img-upload">
                <div class="sh-img-upload__grid">
                  <div
                    v-for="(imgUrl, idx) in officialPublishImageUrls"
                    :key="idx"
                    class="sh-img-upload__thumb"
                  >
                    <img :src="imgUrl" alt="" @click="previewFn(imgUrl)" />
                    <span class="sh-img-upload__remove" title="删除" @click.stop="removeOfficialPublishImage(idx)">
                      <i class="el-icon-close"></i>
                    </span>
                    <span v-if="idx === 0" class="sh-img-upload__cover">封面</span>
                  </div>
                  <el-upload
                    v-if="officialPublishImageUrls.length < 9"
                    class="sh-img-upload__trigger"
                    :show-file-list="false"
                    :disabled="officialPublishImageUploading"
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    :http-request="uploadOfficialPublishImageRequest"
                  >
                    <div
                      class="sh-img-upload__add"
                      :class="{ 'is-loading': officialPublishImageUploading }"
                    >
                      <i v-if="!officialPublishImageUploading" class="el-icon-plus sh-img-upload__add-icon"></i>
                      <i v-else class="el-icon-loading sh-img-upload__add-icon"></i>
                      <span class="sh-img-upload__add-text">{{
                        officialPublishImageUploading ? "上传中…" : "添加图片"
                      }}</span>
                    </div>
                  </el-upload>
                </div>
                <p class="sh-img-upload__hint">
                  支持 JPG / PNG / GIF / WebP；最多 9 张，<span class="sh-img-upload__hint-em">第 1 张为封面</span>
                </p>
              </div>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="officialPublishForm.title"
                maxlength="200"
                show-word-limit
                placeholder="品牌型号、规格等"
              />
            </el-form-item>
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="officialPublishForm.description"
                type="textarea"
                :rows="5"
                maxlength="400"
                show-word-limit
                placeholder="描述品牌型号、成色、出手原因等"
              />
            </el-form-item>

            <el-divider content-position="left">价格</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="售价(元)" prop="price">
                  <el-input-number
                    v-model="officialPublishForm.price"
                    :min="0.01"
                    :max="9999999.99"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="原价(元)">
                  <el-input-number
                    v-model="officialPublishForm.originalPrice"
                    :min="0"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">发货与地区</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="发货方式" prop="deliveryType">
                  <el-select
                    v-model="officialPublishForm.deliveryType"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="onOfficialPublishDeliveryTypeChange"
                  >
                    <el-option v-for="d in deliveryTypeFormOptions" :key="d.value" :label="d.label" :value="d.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="Number(officialPublishForm.deliveryType) === 1" :gutter="16">
              <el-col :span="24">
                <el-form-item label="快递运费">
                  <el-radio-group
                    v-model="officialPublishForm.expressFreightMode"
                    @change="onOfficialPublishExpressFreightModeChange"
                  >
                    <el-radio label="free">包邮</el-radio>
                    <el-radio label="custom">自定义邮费</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="officialPublishForm.expressFreightMode === 'custom'" :span="12">
                <el-form-item label="邮费(元)">
                  <el-input-number
                    v-model="officialPublishForm.freight"
                    :min="0.01"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="所在地区">
              <el-cascader
                v-model="officialPublishForm.regionCodes"
                :options="regionCascaderOptions"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                placeholder="请选择省 / 市 / 区（可选）"
                style="width: 100%"
              />
              <div class="official-publish-field-hint">不选则前台地区展示为空</div>
            </el-form-item>

            <el-divider content-position="left">品牌与型号</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="品牌">
                  <el-select
                    v-model="officialPublishForm.brandId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="搜索并选择品牌"
                    style="width: 100%"
                    :remote-method="remoteSearchOfficialPublishBrand"
                    :loading="officialPublishBrandSearchLoading"
                    @visible-change="(open) => open && remoteSearchOfficialPublishBrand('')"
                    @change="onOfficialPublishBrandChange"
                  >
                    <el-option
                      v-for="b in officialPublishBrandOptions"
                      :key="'b' + b.id"
                      :label="officialPublishBrandOptionLabel(b)"
                      :value="b.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="型号">
                  <el-select
                    v-model="officialPublishForm.typeId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="请先选品牌，再搜索型号"
                    style="width: 100%"
                    :disabled="!officialPublishForm.brandId"
                    :remote-method="remoteSearchOfficialPublishType"
                    :loading="officialPublishTypeSearchLoading"
                    @visible-change="
                      (open) => open && officialPublishForm.brandId && remoteSearchOfficialPublishType('')
                    "
                    @change="onOfficialPublishTypeChange"
                  >
                    <el-option
                      v-for="t in officialPublishTypeOptions"
                      :key="'t' + t.id"
                      :label="officialPublishTypeOptionLabel(t)"
                      :value="t.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">品牌 / 成色等</el-divider>
            <el-form-item label="成色">
              <el-select v-model="officialPublishForm.conditionLevel" placeholder="可选" clearable style="width: 100%">
                <el-option v-for="c in conditionList" :key="c.value" :label="c.label" :value="c.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="购买渠道">
              <el-select v-model="officialPublishForm.purchaseChannel" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="p in purchaseChannelList" :key="p.value" :label="p.label" :value="p.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="剩余保质期">
              <el-select v-model="officialPublishForm.shelfLife" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="s in shelfLifeList" :key="s.value" :label="s.label" :value="s.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="规格类型">
              <el-select v-model="officialPublishForm.specType" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="s in specTypeList" :key="s.value" :label="s.label" :value="s.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="适用性别">
              <el-select v-model="officialPublishForm.gender" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="g in genderList" :key="g.value" :label="g.label" :value="g.value" />
              </el-select>
            </el-form-item>

            <el-divider content-position="left">还价与安心购</el-divider>
            <el-form-item label="接受还价">
              <el-select
                v-model="officialPublishForm.allowBargain"
                style="width: 160px"
                @change="onOfficialPublishAllowBargainChange"
              >
                <el-option label="否" :value="0" />
                <el-option label="是" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="officialPublishForm.allowBargain === 1" label="还价最低(元)" prop="minBargainPrice">
              <el-input-number
                v-model="officialPublishForm.minBargainPrice"
                :min="0.01"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 220px"
              />
              <span class="official-publish-field-hint inline-hint">须低于售价</span>
            </el-form-item>
            <el-row v-if="officialPublishForm.allowBargain === 1" :gutter="16">
              <el-col :span="12">
                <el-form-item label="保证金比例">
                  <el-input-number
                    v-model="officialPublishForm.depositRate"
                    :min="0"
                    :max="1"
                    :precision="2"
                    :step="0.01"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="保证金金额">
                  <el-input-number
                    v-model="officialPublishForm.depositAmount"
                    :min="0"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="officialPublishVisible = false">取消</el-button>
        <el-button type="primary" :loading="officialPublishSubmitting" @click="submitOfficialPublishFn">发布并上架</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime, isJSON } from "@/util/utils";
import { regionData, CodeToText } from "element-china-area-data";

export default {
  data() {
    return {
      /** all：全量列表；audit：仅待人工审核 status=4 */
      activeMainTab: "all",
      loading: false,

      statusOptions: [
        { label: "全部", value: null },
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
        { label: "已售出", value: 2 },
        { label: "已删除", value: 3 },
        { label: "待人工审核", value: 4 },
        { label: "待修改", value: 5 },
        { label: "人工驳回", value: 6 },
      ],

      query: {
        status: null,
        title: "",
        sellerNickName: "",
      },

      /** 省市区三级（element-china-area-data），用于 el-cascader */
      regionCascaderOptions: regionData,

      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      detailVisible: false,
      detail: null,

      auditDialogVisible: false,
      auditRow: null,
      auditRejectRemark: "",
      auditSubmitLoading: false,

      editVisible: false,
      editLoading: false,
      editSubmitLoading: false,
      editRaw: null,
      editForm: null,
      editImageUrls: [],
      editImageUploading: false,

      officialPublishVisible: false,
      officialPublishLoading: false,
      officialPublishSubmitting: false,
      /** 后台「官方帐号列表」全部行，用于发闲置时选择卖家 */
      officialAccountList: [],
      officialPublishForm: null,
      officialPublishImageUrls: [],
      officialPublishImageUploading: false,
      consignorSearchOptions: [],
      consignorSearchLoading: false,
      consignorSearchTimer: null,
      officialPublishBrandOptions: [],
      officialPublishBrandSearchLoading: false,
      officialPublishBrandSearchTimer: null,
      officialPublishTypeOptions: [],
      officialPublishTypeSearchLoading: false,
      officialPublishTypeSearchTimer: null,
      officialPublishSelectedBrand: null,
      officialPublishSelectedType: null,
      officialPublishRules: {
        officialSellerUserId: [{ required: true, message: "请选择上架官方帐号", trigger: "change" }],
        consignorUserId: [{ required: true, message: "请搜索并选择寄售货主", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "change" }],
        deliveryType: [{ required: true, message: "请选择发货方式", trigger: "change" }],
      },

      editRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "change" }],
        quantity: [{ required: true, message: "请输入库存", trigger: "change" }],
        status: [{ required: true, message: "请选择售卖状态", trigger: "change" }],
        minBargainPrice: [
          {
            validator: (rule, value, callback) => {
              const f = this.editForm;
              if (!f || f.allowBargain !== 1) {
                callback();
                return;
              }
              if (value == null || value === "") {
                callback(new Error("接受还价时请填写还价最低金额"));
                return;
              }
              const n = Number(value);
              if (Number.isNaN(n) || n <= 0) {
                callback(new Error("还价最低金额须大于 0"));
                return;
              }
              if (f.price != null && n >= Number(f.price)) {
                callback(new Error("还价最低金额须低于售价"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        inspectionFee: [
          {
            validator: (rule, value, callback) => {
              const f = this.editForm;
              if (!f || f.allowInspection !== 1) {
                callback();
                return;
              }
              if (value == null || value === "") {
                callback();
                return;
              }
              const n = Number(value);
              if (Number.isNaN(n) || n < 0) {
                callback(new Error("安心购费用须为不小于 0 的数字"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },

      /** 编辑弹窗内可选状态（不含已售出 2，列表/详情仍展示） */
      editStatusOptions: [
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
        { label: "已删除", value: 3 },
        { label: "待人工审核", value: 4 },
        { label: "待修改", value: 5 },
        { label: "人工驳回", value: 6 },
      ],

      conditionList: [
        { label: "全新", value: 1 },
        { label: "几乎全新", value: 2 },
        { label: "轻微使用", value: 3 },
        { label: "明显使用", value: 4 },
        { label: "需要维修", value: 5 },
      ],
      purchaseChannelList: [
        { label: "品牌专柜", value: "counter" },
        { label: "其他线下渠道", value: "offline" },
        { label: "品牌官网", value: "official" },
      ],
      shelfLifeList: [
        { label: "1年以上", value: "y1" },
        { label: "7-12个月", value: "m7_12" },
        { label: "0-6个月", value: "m0_6" },
      ],
      specTypeList: [
        { label: "套装", value: "set" },
        { label: "小样", value: "sample" },
        { label: "正常规格", value: "normal" },
      ],
      genderList: [
        { label: "男", value: "male" },
        { label: "女", value: "female" },
        { label: "男女通用", value: "unisex" },
      ],
      deliveryTypeList: [
        { label: "快递", value: 1 },
        { label: "自提", value: 2 },
        { label: "同城", value: 3 },
      ],
    };
  },

  computed: {
    /** 卖家闲置商品列表：0；官方寄售商品列表：1 */
    listProductType() {
      return this.$route.path === "/secondhandOfficialProduct" ? 1 : 0;
    },
    historyArr() {
      const sub = this.listProductType === 1 ? "官方寄售商品列表" : "卖家闲置商品列表";
      return ["商品管理", sub];
    },
    /** 官方寄售商品列表不展示人工审核 Tab/入口及相关列 */
    showManualAuditUi() {
      return this.listProductType === 0;
    },
    isOfficialConsignList() {
      return this.listProductType === 1;
    },
    /** 表单可选配送方式（不含已下线的同城） */
    deliveryTypeFormOptions() {
      return [
        { label: "快递", value: 1 },
        { label: "自提", value: 2 },
      ];
    },
    detailAttrExtra() {
      if (!this.detail || !this.detail.attrJson) return {};
      try {
        if (isJSON(this.detail.attrJson)) {
          const o = JSON.parse(this.detail.attrJson);
          return o.attrExtra && typeof o.attrExtra === "object" ? o.attrExtra : {};
        }
      } catch (e) {}
      return {};
    },
  },

  watch: {
    "$route.path"(path) {
      this.currentPage = 1;
      if (path === "/secondhandOfficialProduct" && this.activeMainTab === "audit") {
        this.activeMainTab = "all";
      }
      this.fetchList(1);
    },
  },

  mounted() {
    this.fetchList(1);
  },

  methods: {
    statusLabel(v) {
      if (v === 0) return "下架";
      if (v === 1) return "上架";
      if (v === 2) return "已售出";
      if (v === 3) return "已删除";
      if (v === 4) return "待人工审核";
      if (v === 5) return "待修改";
      if (v === 6) return "人工驳回";
      return String(v == null ? "-" : v);
    },

    statusColor(v) {
      if (v === 4) return "#e29428";
      if (v === 5) return "#f56c6c";
      if (v === 6) return "#e6a23c";
      if (v === 1) return "#67c23a";
      return "#999";
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    labelInList(value, list) {
      if (value == null || value === "") return "-";
      const item = (list || []).find((x) => x.value === value);
      return item ? item.label : String(value);
    },

    conditionLabel(level) {
      return this.labelInList(level, this.conditionList);
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toFixed(2);
    },

    formatPercent(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return `${(n * 100).toFixed(0)}%`;
    },

    yesNoLabel(v) {
      if (v === 1 || v === true) return "是";
      if (v === 0 || v === false) return "否";
      return "-";
    },

    detailTooltipContent(val) {
      if (val == null || val === "") return "-";
      return String(val);
    },

    detailTooltipDisabled(val) {
      return val == null || String(val).trim() === "";
    },

    imageList(imagesStr) {
      if (!imagesStr) return [];
      try {
        if (isJSON(imagesStr)) {
          const arr = JSON.parse(imagesStr);
          return Array.isArray(arr) ? arr : [];
        }
      } catch (e) {}
      // 兼容逗号分隔
      return String(imagesStr)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },

    firstImage(imagesStr) {
      const arr = this.imageList(imagesStr);
      return arr.length ? arr[0] : "";
    },

    previewFn(url) {
      if (!url) return;
      window.open(url);
    },

    /** 审核弹窗：商品描述展示 */
    auditDescriptionDisplay(row) {
      if (!row || row.description == null) return "-";
      const s = String(row.description).trim();
      return s || "-";
    },

    handleMainTabClick() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    resetFn() {
      this.query = { status: null, title: "", sellerNickName: "" };
      this.fetchList(1);
      this.currentPage = 1;
    },

    searchFn() {
      this.fetchList(1);
      this.currentPage = 1;
    },

    changePage(p) {
      this.fetchList(p);
    },

    fetchList(page) {
      this.loading = true;

      const obj = {
        page: page || 1,
        size: this.pageSize,
        productType: this.listProductType,
      };

      if (this.activeMainTab === "audit") {
        obj.status = 4;
      } else if (this.query.status != null) {
        obj.status = this.query.status;
      }
      if (this.query.title) obj.title = this.query.title;
      const nick = String(this.query.sellerNickName || "").trim();
      if (nick) obj.sellerNickName = nick;

      this.$https(this.$api.api.selSecondhandProduct, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    detailFn(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detail = null;

      this.$https(this.$api.api.getSecondhandProductById, { id: row.id }, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.detail = res.data.data;
        } else {
          this.$message.error((res.data && res.data.msg) || "查询详情失败");
        }
      });
    },

    openAuditDialog(row) {
      if (!row || !row.id) return;
      this.auditRow = row;
      this.auditRejectRemark = "";
      this.auditDialogVisible = true;
    },

    onAuditDialogClosed() {
      this.auditRow = null;
      this.auditRejectRemark = "";
      this.auditSubmitLoading = false;
    },

    submitAuditApprove() {
      if (!this.auditRow || !this.auditRow.id) return;
      const auditBy = this.getAuditBy();
      this.auditSubmitLoading = true;
      this.$https(
        this.$api.api.auditSecondhandApprove,
        { id: this.auditRow.id, auditBy: auditBy, auditRemark: "" },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("审核通过");
            this.auditDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.auditSubmitLoading = false;
        });
    },

    submitAuditReject() {
      const remark = String(this.auditRejectRemark || "").trim();
      if (!remark) {
        this.$message.error("请输入驳回原因");
        return;
      }
      if (!this.auditRow || !this.auditRow.id) return;
      const auditBy = this.getAuditBy();
      this.auditSubmitLoading = true;
      this.$https(
        this.$api.api.auditSecondhandReject,
        { id: this.auditRow.id, auditBy: auditBy, auditRemark: remark },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已驳回");
            this.auditDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.auditSubmitLoading = false;
        });
    },

    getAuditBy() {
      // 你项目里通常把登录信息存 sessionStorage
      try {
        const u = sessionStorage.getItem("USER");
        if (u) {
          const obj = JSON.parse(u);
          return obj.nickName || obj.username || obj.account || "admin";
        }
      } catch (e) {}
      return "admin";
    },

    normalizeUploadedImageUrl(path) {
      if (!path || typeof path !== "string") return "";
      const p = path.trim();
      if (/^https?:\/\//i.test(p)) return p;
      const base = "https://hzshixiang.site";
      return p.startsWith("/") ? base + p : `${base}/${p}`;
    },

    uploadEditImageRequest(option) {
      if (this.editImageUrls.length >= 9) {
        this.$message.warning("最多 9 张图片");
        return;
      }
      const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
      const form = new FormData();
      form.append("file", option.file);
      form.append("no", no);
      this.editImageUploading = true;
      this.$https(this.$api.api.uploadImg, form, "POST")
        .then((res) => {
          const body = res && res.data;
          const code = body && body.code;
          // 后端 FileUpController 成功时可能未设 code，BaseResponseEntity 默认为 0；其它接口常用 200 / 1
          const uploadOk =
            body &&
            (code === 200 || code === 1 || code === 0) &&
            body.data != null &&
            !(typeof body.data === "string" && body.data === "null");
          if (uploadOk) {
            const d = body.data;
            const raw =
              typeof d === "string"
                ? d
                : (d && (d.path || d.url || d.fileUrl || d.fullPath)) || "";
            const url = this.normalizeUploadedImageUrl(String(raw).trim());
            if (url) {
              this.editImageUrls.push(url);
              if (typeof option.onSuccess === "function") option.onSuccess(body, option.file);
            } else {
              this.$message.error("未返回图片地址");
              if (typeof option.onError === "function") option.onError(new Error("empty url"));
            }
          } else {
            this.$message.error((body && body.msg) || "上传失败");
            if (typeof option.onError === "function") option.onError(new Error("fail"));
          }
        })
        .catch(() => {
          this.$message.error("上传失败");
          if (typeof option.onError === "function") option.onError(new Error("network"));
        })
        .finally(() => {
          this.editImageUploading = false;
        });
    },

    removeEditImage(index) {
      if (index < 0 || index >= this.editImageUrls.length) return;
      this.editImageUrls.splice(index, 1);
    },

    editFn(row) {
      if (!row || !row.id) return;
      this.editVisible = true;
      this.editLoading = true;
      this.editRaw = null;
      this.editForm = null;
      this.editImageUrls = [];
      this.$https(this.$api.api.getSecondhandProductById, { id: row.id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.editRaw = res.data.data;
            this.initEditFormFromRaw();
          } else {
            this.$message.error((res.data && res.data.msg) || "加载失败");
            this.editVisible = false;
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },

    initEditFormFromRaw() {
      const r = this.editRaw;
      if (!r) return;
      let statusVal = r.status != null ? r.status : 1;
      if (statusVal === 2) {
        statusVal = null;
        this.$message.info("当前为已售出，编辑不包含该状态，请重新选择商品状态后再保存");
      }
      let extra = {};
      try {
        if (r.attrJson && isJSON(r.attrJson)) {
          const parsed = JSON.parse(r.attrJson);
          if (parsed && parsed.attrExtra && typeof parsed.attrExtra === "object") {
            extra = parsed.attrExtra;
          }
        }
      } catch (e) {}
      let deliveryType = r.deliveryType != null ? Number(r.deliveryType) : 1;
      if (deliveryType === 3) {
        deliveryType = 1;
        this.$message.warning("同城配送已停用，已改为「快递」，请确认运费与地区");
      }
      const freightNum = r.freight != null ? Number(r.freight) : 0;
      let expressFreightMode = "free";
      if (deliveryType === 1) {
        expressFreightMode = freightNum > 0 ? "custom" : "free";
      }

      this.editForm = {
        title: r.title || "",
        description: r.description || "",
        status: statusVal,
        price: r.price != null ? Number(r.price) : null,
        originalPrice: r.originalPrice != null ? Number(r.originalPrice) : null,
        quantity: r.quantity != null ? Number(r.quantity) : 1,
        conditionLevel: r.conditionLevel,
        purchaseChannel: extra.purchaseChannel != null && extra.purchaseChannel !== "" ? extra.purchaseChannel : null,
        shelfLife: extra.shelfLife != null && extra.shelfLife !== "" ? extra.shelfLife : null,
        specType: extra.specType != null && extra.specType !== "" ? extra.specType : null,
        gender: extra.gender != null && extra.gender !== "" ? extra.gender : null,
        deliveryType,
        expressFreightMode,
        freight:
          deliveryType === 1 && expressFreightMode === "custom"
            ? freightNum > 0
              ? freightNum
              : 0.01
            : deliveryType === 1
              ? 0
              : 0,
        regionCodes: [],
        location: r.location || "",
        allowBargain: r.allowBargain === 1 || r.allowBargain === true ? 1 : 0,
        minBargainPrice: r.minBargainPrice != null ? Number(r.minBargainPrice) : null,
        depositRate: r.depositRate != null ? Number(r.depositRate) : 0.05,
        depositAmount: r.depositAmount != null ? Number(r.depositAmount) : null,
        allowInspection: r.allowInspection === 1 || r.allowInspection === true ? 1 : 0,
        inspectionFee: r.inspectionFee != null ? Number(r.inspectionFee) : null,
      };
      this.editImageUrls = [...this.imageList(r.images)];
    },

    /** 保存时把成色 + attrExtra 写回 attrJson，并保留原 JSON 其它字段 */
    buildAttrJsonForSave(editForm, raw) {
      let base = {};
      try {
        if (raw.attrJson && isJSON(raw.attrJson)) {
          base = JSON.parse(raw.attrJson);
        }
      } catch (e) {
        base = {};
      }
      if (base == null || typeof base !== "object") base = {};
      if (base.v == null) base.v = 1;
      base.conditionLevel =
        editForm.conditionLevel != null ? editForm.conditionLevel : raw.conditionLevel != null ? raw.conditionLevel : base.conditionLevel;
      base.categoryId = raw.categoryId != null ? raw.categoryId : base.categoryId;
      base.brandId = raw.brandId != null ? raw.brandId : base.brandId;
      base.typeId = raw.typeId != null ? raw.typeId : base.typeId;
      if (raw.brandName != null && raw.brandName !== "") base.brandName = raw.brandName;
      if (raw.typeName != null && raw.typeName !== "") base.typeName = raw.typeName;
      const prevExtra =
        base.attrExtra && typeof base.attrExtra === "object" && !Array.isArray(base.attrExtra) ? { ...base.attrExtra } : {};
      base.attrExtra = {
        ...prevExtra,
        purchaseChannel: editForm.purchaseChannel != null && editForm.purchaseChannel !== "" ? editForm.purchaseChannel : null,
        shelfLife: editForm.shelfLife != null && editForm.shelfLife !== "" ? editForm.shelfLife : null,
        specType: editForm.specType != null && editForm.specType !== "" ? editForm.specType : null,
        gender: editForm.gender != null && editForm.gender !== "" ? editForm.gender : null,
      };
      if (base.moreExpanded == null) base.moreExpanded = 1;
      if (base.attrCardRevealedOnce == null) base.attrCardRevealedOnce = 1;
      try {
        return JSON.stringify(base);
      } catch (e) {
        return raw.attrJson || "{}";
      }
    },

    onEditAllowBargainChange(val) {
      if (val !== 1) {
        if (this.editForm) this.editForm.minBargainPrice = null;
        this.$nextTick(() => {
          if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate(["minBargainPrice"]);
        });
      }
    },

    onEditAllowInspectionChange(val) {
      if (val !== 1) {
        if (this.editForm) this.editForm.inspectionFee = null;
        this.$nextTick(() => {
          if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate(["inspectionFee"]);
        });
      }
    },

    onEditDialogClosed() {
      this.editRaw = null;
      this.editForm = null;
      this.editImageUrls = [];
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate();
        }
      });
    },

    openOfficialPublishDialog() {
      this.officialPublishLoading = true;
      this.$https(this.$api.api.selOfficialUserMgmtList, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const list = Array.isArray(res.data.data) ? res.data.data : [];
            this.officialAccountList = list;
            if (!list.length) {
              this.$message.error("未配置官方寄售帐号，请先在「用户管理 → 官方帐号列表」中添加");
              return;
            }
            this.resetOfficialPublishForm();
            this.officialPublishForm.officialSellerUserId = list[0].officialUserId;
            this.officialPublishVisible = true;
          } else {
            this.$message.error((res.data && res.data.msg) || "加载官方帐号失败");
          }
        })
        .catch(() => {
          this.$message.error("加载官方帐号失败");
        })
        .finally(() => {
          this.officialPublishLoading = false;
        });
    },

    displayOfficialAccountNick(acc) {
      if (!acc) return "—";
      const n = acc.nickName != null && String(acc.nickName).trim() !== "" ? String(acc.nickName).trim() : "";
      return n || "（未设置昵称）";
    },

    officialAccountOptionLabel(acc) {
      if (!acc) return "";
      const nick = this.displayOfficialAccountNick(acc);
      const rm =
        acc.remark != null && String(acc.remark).trim() !== "" ? ` · ${String(acc.remark).trim()}` : "";
      return `${nick}（ID ${acc.officialUserId}）${rm}`;
    },

    resetOfficialPublishForm() {
      this.consignorSearchOptions = [];
      this.officialPublishBrandOptions = [];
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedBrand = null;
      this.officialPublishSelectedType = null;
      this.officialPublishForm = {
        officialSellerUserId: null,
        consignorUserId: null,
        title: "",
        description: "",
        price: null,
        originalPrice: null,
        quantity: 1,
        conditionLevel: null,
        brandId: null,
        typeId: null,
        brandName: "",
        typeName: "",
        regionCodes: [],
        expressFreightMode: "free",
        deliveryType: 1,
        freight: 0,
        purchaseChannel: null,
        shelfLife: null,
        specType: null,
        gender: null,
        allowBargain: 0,
        minBargainPrice: null,
        depositRate: 0.05,
        depositAmount: null,
        allowInspection: 0,
        inspectionFee: null,
      };
      this.officialPublishImageUrls = [];
    },

    onOfficialPublishAllowBargainChange(val) {
      if (val !== 1 && this.officialPublishForm) {
        this.officialPublishForm.minBargainPrice = null;
      }
      this.$nextTick(() => {
        if (this.$refs.officialPublishFormRef) {
          this.$refs.officialPublishFormRef.clearValidate(["minBargainPrice"]);
        }
      });
    },

    consignorUserOptionLabel(u) {
      if (!u) return "";
      const nick = u.nickName != null && String(u.nickName).trim() !== "" ? String(u.nickName).trim() : "";
      return nick ? `${nick}（ID ${u.id}）` : `用户 ID ${u.id}`;
    },

    officialPublishBrandOptionLabel(b) {
      if (!b) return "";
      const n = b.name != null ? String(b.name).trim() : "";
      return n || `ID ${b.id}`;
    },

    officialPublishTypeOptionLabel(t) {
      if (!t) return "";
      const n = t.name != null ? String(t.name).trim() : "";
      const en =
        t.englishName != null && String(t.englishName).trim() !== ""
          ? ` / ${String(t.englishName).trim()}`
          : "";
      return (n || `ID ${t.id}`) + en;
    },

    remoteSearchOfficialPublishBrand(query) {
      if (this.officialPublishBrandSearchTimer) {
        clearTimeout(this.officialPublishBrandSearchTimer);
        this.officialPublishBrandSearchTimer = null;
      }
      const q = String(query || "").trim();
      this.officialPublishBrandSearchTimer = setTimeout(() => {
        this.officialPublishBrandSearchLoading = true;
        const payload = { page: 1, size: 30 };
        if (q) payload.name = q;
        this.$https(this.$api.api.selBrand, payload, "POST")
          .then((res) => {
            let arr = [];
            if (res.data && res.data.code == 200) {
              arr = res.data.data || [];
            }
            if (
              this.officialPublishForm &&
              this.officialPublishForm.brandId != null &&
              this.officialPublishSelectedBrand &&
              this.officialPublishSelectedBrand.id === this.officialPublishForm.brandId &&
              !arr.some((x) => x.id === this.officialPublishSelectedBrand.id)
            ) {
              arr = [this.officialPublishSelectedBrand, ...arr];
            }
            this.officialPublishBrandOptions = arr;
          })
          .catch(() => {
            this.officialPublishBrandOptions = [];
          })
          .finally(() => {
            this.officialPublishBrandSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishBrandChange(val) {
      if (!this.officialPublishForm) return;
      if (val == null || val === "") {
        this.officialPublishForm.brandName = "";
        this.officialPublishForm.typeId = null;
        this.officialPublishForm.typeName = "";
        this.officialPublishTypeOptions = [];
        this.officialPublishSelectedBrand = null;
        this.officialPublishSelectedType = null;
        return;
      }
      const row = this.officialPublishBrandOptions.find((b) => b.id === val);
      if (row) {
        this.officialPublishSelectedBrand = { ...row };
        this.officialPublishForm.brandName = row.name != null ? String(row.name).trim() : "";
      }
      this.officialPublishForm.typeId = null;
      this.officialPublishForm.typeName = "";
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedType = null;
    },

    remoteSearchOfficialPublishType(query) {
      const bid = this.officialPublishForm && this.officialPublishForm.brandId;
      if (bid == null || bid === "") {
        this.officialPublishTypeOptions = [];
        return;
      }
      if (this.officialPublishTypeSearchTimer) {
        clearTimeout(this.officialPublishTypeSearchTimer);
        this.officialPublishTypeSearchTimer = null;
      }
      const q = String(query || "").trim();
      this.officialPublishTypeSearchTimer = setTimeout(() => {
        this.officialPublishTypeSearchLoading = true;
        const payload = { brandId: bid, page: 1, size: 50 };
        if (q) payload.name = q;
        this.$https(this.$api.api.selModel, payload, "POST")
          .then((res) => {
            let arr = [];
            if (res.data && res.data.code == 200) {
              arr = res.data.data || [];
            }
            if (
              this.officialPublishForm &&
              this.officialPublishForm.typeId != null &&
              this.officialPublishSelectedType &&
              this.officialPublishSelectedType.id === this.officialPublishForm.typeId &&
              !arr.some((x) => x.id === this.officialPublishSelectedType.id)
            ) {
              arr = [this.officialPublishSelectedType, ...arr];
            }
            this.officialPublishTypeOptions = arr;
          })
          .catch(() => {
            this.officialPublishTypeOptions = [];
          })
          .finally(() => {
            this.officialPublishTypeSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishTypeChange(val) {
      if (!this.officialPublishForm) return;
      if (val == null || val === "") {
        this.officialPublishForm.typeName = "";
        this.officialPublishSelectedType = null;
        return;
      }
      const row = this.officialPublishTypeOptions.find((t) => t.id === val);
      if (row) {
        this.officialPublishSelectedType = { ...row };
        this.officialPublishForm.typeName = row.name != null ? String(row.name).trim() : "";
      }
    },

    remoteSearchConsignorUser(query) {
      if (this.consignorSearchTimer) {
        clearTimeout(this.consignorSearchTimer);
        this.consignorSearchTimer = null;
      }
      const q = String(query || "").trim();
      if (!q) {
        this.consignorSearchOptions = [];
        return;
      }
      this.consignorSearchTimer = setTimeout(() => {
        this.consignorSearchLoading = true;
        this.$https(this.$api.api.selUser, { nickName: q, page: 1, size: 30 }, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.consignorSearchOptions = res.data.data || [];
            } else {
              this.consignorSearchOptions = [];
            }
          })
          .catch(() => {
            this.consignorSearchOptions = [];
          })
          .finally(() => {
            this.consignorSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishDialogClosed() {
      this.officialPublishForm = null;
      this.officialAccountList = [];
      this.officialPublishImageUrls = [];
      this.consignorSearchOptions = [];
      this.officialPublishBrandOptions = [];
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedBrand = null;
      this.officialPublishSelectedType = null;
      if (this.consignorSearchTimer) {
        clearTimeout(this.consignorSearchTimer);
        this.consignorSearchTimer = null;
      }
      if (this.officialPublishBrandSearchTimer) {
        clearTimeout(this.officialPublishBrandSearchTimer);
        this.officialPublishBrandSearchTimer = null;
      }
      if (this.officialPublishTypeSearchTimer) {
        clearTimeout(this.officialPublishTypeSearchTimer);
        this.officialPublishTypeSearchTimer = null;
      }
      this.$nextTick(() => {
        if (this.$refs.officialPublishFormRef) {
          this.$refs.officialPublishFormRef.clearValidate();
        }
      });
    },

    parseOptionalPositiveInt(str) {
      if (str == null || String(str).trim() === "") return null;
      const n = parseInt(String(str).trim(), 10);
      return Number.isNaN(n) || n < 1 ? null : n;
    },

    /** 省市区 code 数组 → 连续中文，写入 SecondhandProduct.location */
    formatLocationFromCodes(codes) {
      if (!codes || !codes.length) return "";
      const parts = codes.map((c) => CodeToText[c]).filter(Boolean);
      return parts.join("");
    },

    resolveFreightForPayload(f) {
      const deliveryType = f.deliveryType != null ? Number(f.deliveryType) : 1;
      if (deliveryType === 2) return 0;
      if (deliveryType === 1) {
        if (f.expressFreightMode === "free") return 0;
        let freight = f.freight != null && f.freight !== "" ? Number(f.freight) : 0;
        if (Number.isNaN(freight) || freight < 0) freight = 0;
        return freight;
      }
      const fb = f.freight != null && f.freight !== "" ? Number(f.freight) : 0;
      return Number.isNaN(fb) ? 0 : fb;
    },

    onOfficialPublishDeliveryTypeChange(val) {
      const t = Number(val);
      if (!this.officialPublishForm) return;
      if (t === 2) {
        this.officialPublishForm.freight = 0;
      }
      if (t === 1) {
        this.officialPublishForm.expressFreightMode = "free";
        this.officialPublishForm.freight = 0;
      }
    },

    onOfficialPublishExpressFreightModeChange(val) {
      if (!this.officialPublishForm) return;
      if (val === "free") {
        this.officialPublishForm.freight = 0;
      } else if (val === "custom") {
        const cur = Number(this.officialPublishForm.freight);
        if (this.officialPublishForm.freight == null || this.officialPublishForm.freight === "" || cur <= 0) {
          this.officialPublishForm.freight = 0.01;
        }
      }
    },

    onEditDeliveryTypeChange(val) {
      const t = Number(val);
      if (!this.editForm) return;
      if (t === 2) {
        this.editForm.freight = 0;
      }
      if (t === 1) {
        this.editForm.expressFreightMode = "free";
        this.editForm.freight = 0;
      }
    },

    onEditExpressFreightModeChange(val) {
      if (!this.editForm) return;
      if (val === "free") {
        this.editForm.freight = 0;
      } else if (val === "custom") {
        const cur = Number(this.editForm.freight);
        if (this.editForm.freight == null || this.editForm.freight === "" || cur <= 0) {
          this.editForm.freight = 0.01;
        }
      }
    },

    onEditRegionChange(val) {
      if (!this.editForm) return;
      if (val && val.length) {
        this.editForm.location = this.formatLocationFromCodes(val);
      }
    },

    buildOfficialPublishAttrJson() {
      const f = this.officialPublishForm;
      if (!f) return "{}";
      const brandId = this.parseOptionalPositiveInt(f.brandId != null ? String(f.brandId) : "");
      const typeId = this.parseOptionalPositiveInt(f.typeId != null ? String(f.typeId) : "");
      const base = {
        v: 1,
        conditionLevel: f.conditionLevel != null ? f.conditionLevel : 1,
        categoryId: null,
        brandId,
        typeId,
        moreExpanded: 1,
        attrCardRevealedOnce: 1,
        attrExtra: {
          purchaseChannel: f.purchaseChannel != null && f.purchaseChannel !== "" ? f.purchaseChannel : null,
          shelfLife: f.shelfLife != null && f.shelfLife !== "" ? f.shelfLife : null,
          specType: f.specType != null && f.specType !== "" ? f.specType : null,
          gender: f.gender != null && f.gender !== "" ? f.gender : null,
        },
      };
      const bn = f.brandName != null ? String(f.brandName).trim() : "";
      const tn = f.typeName != null ? String(f.typeName).trim() : "";
      if (bn) base.brandName = bn;
      if (tn) base.typeName = tn;
      try {
        return JSON.stringify(base);
      } catch (e) {
        return "{}";
      }
    },

    buildOfficialPublishPayload() {
      const f = this.officialPublishForm;
      const brandId = this.parseOptionalPositiveInt(f.brandId != null ? String(f.brandId) : "");
      const typeId = this.parseOptionalPositiveInt(f.typeId != null ? String(f.typeId) : "");
      const deliveryType = f.deliveryType != null ? Number(f.deliveryType) : 1;
      const freight = this.resolveFreightForPayload(f);
      const location = this.formatLocationFromCodes(f.regionCodes) || "";
      const qty = f.quantity != null ? Math.max(1, parseInt(String(f.quantity), 10) || 1) : 1;
      const allowBargain = f.allowBargain === 1 ? 1 : 0;
      const allowInspection = 0;
      return {
        sellerUserId: f.officialSellerUserId,
        consignorUserId: f.consignorUserId,
        productType: 1,
        title: f.title,
        description: f.description || "",
        price: f.price,
        consignListingPrice: f.price,
        originalPrice: f.originalPrice != null && f.originalPrice !== "" ? f.originalPrice : null,
        images: JSON.stringify(this.officialPublishImageUrls || []),
        categoryId: null,
        brandId,
        typeId,
        conditionLevel: f.conditionLevel != null ? f.conditionLevel : 1,
        deliveryType,
        freight,
        quantity: qty,
        location,
        allowBargain,
        minBargainPrice: allowBargain === 1 && f.minBargainPrice != null && f.minBargainPrice !== "" ? f.minBargainPrice : null,
        depositRate: allowBargain === 1 ? (f.depositRate != null ? f.depositRate : 0.05) : null,
        depositAmount:
          allowBargain === 1 && f.depositAmount != null && f.depositAmount !== "" ? f.depositAmount : null,
        allowInspection,
        inspectionFee:
          allowInspection === 1 && f.inspectionFee != null && f.inspectionFee !== "" ? f.inspectionFee : null,
        attrJson: this.buildOfficialPublishAttrJson(),
      };
    },

    uploadOfficialPublishImageRequest(option) {
      if (this.officialPublishImageUrls.length >= 9) {
        this.$message.warning("最多 9 张图片");
        return;
      }
      const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
      const form = new FormData();
      form.append("file", option.file);
      form.append("no", no);
      this.officialPublishImageUploading = true;
      this.$https(this.$api.api.uploadImg, form, "POST")
        .then((res) => {
          const body = res && res.data;
          const code = body && body.code;
          const uploadOk =
            body &&
            (code === 200 || code === 1 || code === 0) &&
            body.data != null &&
            !(typeof body.data === "string" && body.data === "null");
          if (uploadOk) {
            const d = body.data;
            const raw =
              typeof d === "string"
                ? d
                : (d && (d.path || d.url || d.fileUrl || d.fullPath)) || "";
            const url = this.normalizeUploadedImageUrl(String(raw).trim());
            if (url) {
              this.officialPublishImageUrls.push(url);
              if (typeof option.onSuccess === "function") option.onSuccess(body, option.file);
            } else {
              this.$message.error("未返回图片地址");
              if (typeof option.onError === "function") option.onError(new Error("empty url"));
            }
          } else {
            this.$message.error((body && body.msg) || "上传失败");
            if (typeof option.onError === "function") option.onError(new Error("fail"));
          }
        })
        .catch(() => {
          this.$message.error("上传失败");
          if (typeof option.onError === "function") option.onError(new Error("network"));
        })
        .finally(() => {
          this.officialPublishImageUploading = false;
        });
    },

    removeOfficialPublishImage(index) {
      if (index < 0 || index >= this.officialPublishImageUrls.length) return;
      this.officialPublishImageUrls.splice(index, 1);
    },

    submitOfficialPublishFn() {
      if (!this.$refs.officialPublishFormRef || !this.officialPublishForm) return;
      this.$refs.officialPublishFormRef.validate((valid) => {
        if (!valid) return;
        if (!this.officialPublishImageUrls.length) {
          this.$message.warning("请至少上传一张商品图");
          return;
        }
        const f = this.officialPublishForm;
        if (f.allowBargain === 1) {
          const minP = Number(f.minBargainPrice);
          if (f.minBargainPrice == null || f.minBargainPrice === "" || Number.isNaN(minP) || minP <= 0) {
            this.$message.warning("开启还价时请填写有效的还价最低金额");
            return;
          }
          const sale = Number(f.price);
          if (!Number.isNaN(sale) && minP >= sale) {
            this.$message.warning("还价最低金额须低于售价");
            return;
          }
        }
        if (Number(f.deliveryType) === 1 && f.expressFreightMode === "custom") {
          const fr = Number(f.freight);
          if (f.freight == null || f.freight === "" || Number.isNaN(fr) || fr <= 0) {
            this.$message.warning("选择自定义邮费时请填写大于 0 的邮费");
            return;
          }
        }
        this.officialPublishSubmitting = true;
        const payload = this.buildOfficialPublishPayload();
        this.$https(this.$api.api.addSecondhandProduct, payload, "POST")
          .then((res) => {
            if (!res.data || res.data.code != 200) {
              this.$message.error((res.data && res.data.msg) || "发布失败");
              return;
            }
            const created = res.data.data;
            const id = created && created.id;
            if (!id) {
              this.$message.success("发布成功");
              this.officialPublishVisible = false;
              this.fetchList(1);
              return;
            }
            return this.$https(this.$api.api.getSecondhandProductById, { id }, "GET").then((r2) => {
              if (!r2.data || r2.data.code != 200 || !r2.data.data) {
                this.$message.warning("商品已创建，请在列表中手动上架");
                this.officialPublishVisible = false;
                this.fetchList(1);
                return;
              }
              const full = r2.data.data;
              full.status = 1;
              return this.$https(this.$api.api.updateSecondhandProduct, full, "POST").then((r3) => {
                if (r3.data && r3.data.code == 200) {
                  this.$message.success("发布成功，已上架");
                } else {
                  this.$message.warning((r3.data && r3.data.msg) || "上架失败，请在列表中编辑上架");
                }
                this.officialPublishVisible = false;
                this.fetchList(1);
              });
            });
          })
          .finally(() => {
            this.officialPublishSubmitting = false;
          });
      });
    },

    submitEditFn() {
      if (!this.$refs.editFormRef || !this.editForm || !this.editRaw) return;
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return;
        this.editSubmitLoading = true;
        const payload = { ...this.editRaw };
        payload.title = this.editForm.title;
        payload.description = this.editForm.description;
        payload.status = this.editForm.status;
        payload.price = this.editForm.price;
        if (!this.isOfficialConsignList) {
          payload.originalPrice = this.editForm.originalPrice;
        }
        payload.quantity = this.editForm.quantity;
        payload.conditionLevel = this.editForm.conditionLevel;
        payload.deliveryType = this.editForm.deliveryType;
        payload.freight = this.resolveFreightForPayload(this.editForm);
        if (Number(this.editForm.deliveryType) === 1 && this.editForm.expressFreightMode === "custom") {
          const fr = Number(this.editForm.freight);
          if (
            this.editForm.freight == null ||
            this.editForm.freight === "" ||
            Number.isNaN(fr) ||
            fr <= 0
          ) {
            this.$message.warning("选择自定义邮费时请填写大于 0 的邮费");
            this.editSubmitLoading = false;
            return;
          }
        }
        const locFromCascader = this.formatLocationFromCodes(this.editForm.regionCodes);
        payload.location =
          (locFromCascader && locFromCascader.trim()) ||
          (this.editForm.location && String(this.editForm.location).trim()) ||
          "";
        payload.allowBargain = this.editForm.allowBargain;
        if (this.editForm.allowBargain === 1) {
          payload.minBargainPrice = this.editForm.minBargainPrice;
        } else {
          payload.minBargainPrice = null;
        }
        payload.depositRate = this.editForm.depositRate;
        payload.depositAmount =
          this.editForm.depositAmount != null && this.editForm.depositAmount !== "" ? this.editForm.depositAmount : null;
        if (!this.isOfficialConsignList) {
          payload.allowInspection = this.editForm.allowInspection;
          if (this.editForm.allowInspection === 1) {
            payload.inspectionFee =
              this.editForm.inspectionFee != null && this.editForm.inspectionFee !== ""
                ? this.editForm.inspectionFee
                : null;
          } else {
            payload.inspectionFee = null;
          }
        }
        payload.images = JSON.stringify(this.editImageUrls || []);
        payload.attrJson = this.buildAttrJsonForSave(this.editForm, this.editRaw);
        this.$https(this.$api.api.updateSecondhandProduct, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success((res.data && res.data.msg) || "保存成功");
              this.editVisible = false;
              this.fetchList(this.currentPage);
            } else {
              this.$message.error((res.data && res.data.msg) || "保存失败");
            }
          })
          .finally(() => {
            this.editSubmitLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
  .official-publish-tip {
    font-size: 13px;
    color: #606266;
    margin: 0 0 12px;
    line-height: 1.5;
  }
  .official-publish-field-hint {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    margin-top: 6px;
  }
  .official-publish-consignor-item ::v-deep .el-select,
  .official-publish-official-item ::v-deep .el-select {
    width: 100%;
  }
  .official-publish-wrap {
    margin-top: -4px;
  }
  .official-publish-body {
    max-height: min(520px, calc(90vh - 200px));
    overflow-y: auto;
    padding-right: 4px;
  }
  .official-publish-field-hint.inline-hint {
    display: inline-block;
    margin-top: 0;
    margin-left: 8px;
    vertical-align: middle;
  }
  /* 商品图片：网格缩略图 + 虚线添加格 */
  .sh-img-upload {
    width: 100%;
  }
  .sh-img-upload__grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-start;
  }
  .sh-img-upload__thumb {
    position: relative;
    width: 96px;
    height: 96px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    &:hover {
      border-color: #c0c4cc;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      display: block;
    }
  }
  .sh-img-upload__cover {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    font-size: 11px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.55));
    letter-spacing: 0.5px;
  }
  .sh-img-upload__remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
    transition: background 0.15s ease, transform 0.15s ease;
    &:hover {
      background: rgba(245, 108, 108, 0.95);
      transform: scale(1.05);
    }
  }
  .sh-img-upload__trigger {
    display: block;
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    ::v-deep .el-upload {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      border-radius: 8px;
    }
  }
  .sh-img-upload__add {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px;
    border: 1px dashed #c0c4cc;
    border-radius: 8px;
    background: #fafafa;
    color: #909399;
    font-size: 12px;
    line-height: 1.3;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
    &:hover:not(.is-loading) {
      border-color: #409eff;
      background: #f0f9ff;
      color: #409eff;
    }
    &.is-loading {
      cursor: wait;
      opacity: 0.85;
    }
  }
  .sh-img-upload__add-icon {
    font-size: 22px;
    line-height: 1;
  }
  .sh-img-upload__add-text {
    max-width: 72px;
  }
  .sh-img-upload__hint {
    margin: 10px 0 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
  .sh-img-upload__hint-em {
    color: #606266;
    font-weight: 500;
  }
  .secondhand-main-tabs {
    margin-top: 12px;
    ::v-deep .el-tabs__content {
      display: none;
    }
    ::v-deep .el-tabs__header {
      margin-bottom: 0;
    }
  }
  .audit-dialog-body {
    font-size: 14px;
    color: #303133;
    line-height: 1.6;
    max-height: min(420px, calc(100vh - 280px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
  }
  .audit-dialog-line {
    margin: 0 0 8px;
    word-break: break-all;
  }
  .audit-dialog-block {
    margin-top: 12px;
  }
  .audit-dialog-block__label {
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }
  .audit-dialog-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    img {
      width: 88px;
      height: 88px;
      object-fit: cover;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      cursor: pointer;
      display: block;
    }
  }
  .audit-dialog-empty {
    color: #909399;
    font-size: 13px;
  }
  .audit-dialog-desc {
    margin: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 13px;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    max-height: 120px;
    overflow-y: auto;
  }
  .audit-dialog-violation {
    margin: 0;
    padding: 8px 10px;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 4px;
    font-size: 13px;
    color: #606266;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    max-height: 100px;
    overflow-y: auto;
  }
  .audit-dialog-remark {
    margin-top: 14px;
  }
  .audit-dialog-remark__label {
    margin-bottom: 8px;
    font-size: 13px;
    color: #606266;
  }
  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .topLeft {
    align-items: center;
  }
  .page_box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
  .detail-dialog-body {
    max-height: min(560px, calc(100vh - 200px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;
  }
  .detail-section {
    margin-bottom: 20px;
    &--last {
      margin-bottom: 0;
    }
  }
  .detail-section__title {
    margin: 0 0 10px;
    padding: 0 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    border-left: 3px solid #409eff;
  }
  .detail-field-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    width: 100%;
    /* 仅网格间隙用灰线；空列无格子时透出白底，避免出现大块灰块 */
    background: #ebeef5;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    &--cols2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .detail-field-cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #fff;
    &--full {
      grid-column: 1 / -1;
      width: 100%;
    }
    &--span2 {
      grid-column: span 2;
    }
  }
  .detail-field-label {
    flex-shrink: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  .detail-field-value {
    flex: 1;
    min-width: 0;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    word-break: break-all;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    &--multiline {
      display: block;
      align-items: stretch;
      white-space: pre-wrap;
      max-height: 160px;
      overflow-y: auto;
    }
    &--tooltip {
      display: block;
      min-width: 0;
      width: 100%;
      ::v-deep .el-tooltip {
        display: block;
        width: 100%;
      }
    }
  }
  .detail-field-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    line-height: 1.5;
    cursor: default;
  }
  .detail-seller-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .detail-seller-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
    border: 1px solid #ebeef5;
    flex-shrink: 0;
  }
  .detail-seller-uid {
    color: #909399;
    font-size: 12px;
  }
  .desc-cell-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    cursor: default;
  }
  .edit-status-row {
    width: 100%;
  }
  .edit-status-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
  .edit-bargain-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
}
</style>

<style lang="less">
/* tooltip 挂载在 body，需非 scoped */
.secondhand-desc-tooltip {
  max-width: 480px;
  word-break: break-word;
  line-height: 1.5;
}

.secondhand-detail-dialog .el-dialog__body {
  padding: 12px 20px 10px;
}
.secondhand-detail-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

/* 编辑商品：固定宽度 + 主体区域固定高度内滚动 */
.secondhand-edit-dialog.el-dialog {
  width: 640px !important;
  max-height: 90vh;
  margin-top: 5vh !important;
  display: flex;
  flex-direction: column;
}
.secondhand-edit-dialog .el-dialog__header {
  flex-shrink: 0;
  padding-bottom: 12px;
}
.secondhand-edit-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(560px, calc(90vh - 168px));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 8px 20px 4px;
}
.secondhand-edit-dialog .el-dialog__footer {
  flex-shrink: 0;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

.secondhand-audit-dialog .el-dialog__body {
  padding: 8px 20px 4px;
}
.secondhand-audit-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

.secondhand-official-publish-dialog.el-dialog {
  width: 820px !important;
  max-height: 92vh;
  margin-top: 5vh !important;
  display: flex;
  flex-direction: column;
}
.secondhand-official-publish-dialog .el-dialog__header {
  flex-shrink: 0;
  padding-bottom: 8px;
}
.secondhand-official-publish-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 20px 4px;
  overflow: hidden;
}
.secondhand-official-publish-dialog .el-dialog__footer {
  flex-shrink: 0;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

/* 发闲置：官方帐号下拉（挂载在 body） */
.official-publish-official-dropdown.el-select-dropdown {
  min-width: 380px !important;
}
.official-account-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
  line-height: 1.35;
}
.official-account-opt__avatar-wrap {
  flex-shrink: 0;
}
.official-account-opt__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 1px solid #ebeef5;
}
.official-account-opt__avatar--ph {
  background: #f5f7fa;
  color: #c0c4cc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.official-account-opt__meta {
  min-width: 0;
  flex: 1;
}
.official-account-opt__nick {
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.official-account-opt__sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandProduct/index.vue